import routerOptions0 from "/var/www/setlpn.ru/releases/20250630101912__branch--master__commit--3c8ed359/frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}